import PositioningDeviceTypePictureModal from './positioning-device-type-picture-modal.vue'
export default PositioningDeviceTypePictureModal
